import { getAppValue } from "src/utils/environment";
import { avatarSlice } from "./reducer";

const actions = avatarSlice.actions;

const importDecoders = async () => {
  const { decodeBabyCustomization } = await import(
    "../../babyCustomization-protobuf"
  );
  const { decodeDogCustomization } = await import(
    "../../dogCustomization-protobuf"
  );
  return { decodeBabyCustomization, decodeDogCustomization };
};

const enhancedSaveAvatar = (payload) => async (dispatch) => {
  const { decodeBabyCustomization, decodeDogCustomization } =
    await importDecoders();
  const avatarToSave = payload.avatarCustomization
    ? {
        ...payload,
        avatarCustomization: getAppValue({
          bibino: () => decodeBabyCustomization(payload.avatarCustomization),
          barkio: () => decodeDogCustomization(payload.avatarCustomization)
        })()
      }
    : payload;
  dispatch(actions.saveAvatar(avatarToSave));
};

const enhancedReplaceAvatars = (payload) => async (dispatch) => {
  const { decodeBabyCustomization, decodeDogCustomization } =
    await importDecoders();
  const avatarsToSave = Object.entries(payload).reduce(
    (result, [id, props]) => {
      const avatarCustomization = props.avatarCustomization
        ? getAppValue({
            bibino: () => decodeBabyCustomization(props.avatarCustomization),
            barkio: () => decodeDogCustomization(props.avatarCustomization)
          })()
        : undefined;

      result[id] = {
        ...props,
        avatarCustomization
      };
      return result;
    },
    {}
  );
  dispatch(actions.replaceAvatars(avatarsToSave));
};

const enhancedActions = {
  deleteAvatar: actions.deleteAvatar,
  setDefaultAvatar: actions.setDefaultAvatar,
  saveAvatar: enhancedSaveAvatar,
  replaceAvatars: enhancedReplaceAvatars
};

export const { deleteAvatar, replaceAvatars, saveAvatar, setDefaultAvatar } =
  enhancedActions;
